const Switch = ({ onClick, customClass, value }) => {
  return (
    <button
      onClick={onClick}
      className={`switchContainer${value ? " switchContainerToggled" : ""}${
        customClass ? ` ${customClass}` : ""
      }`}
    >
      <div style={{ left: value ? "30px" : "6px" }} className="switchButton" />
    </button>
  );
};

export default Switch;
